import _stafetCommonStepsProps from 'foundation/js/configurations/_stafetCommonStepsProps'
import { ref, computed, onBeforeMount } from 'vue'
import FormInputTextField from '../FormInputTextField/FormInputTextField.vue'
import FormCheckbox from '../FormCheckbox/FormCheckbox.vue'
import StafetPayment from '../StafetPayment/StafetPayment.vue'
import StafetActions from '../StafetActions/StafetActions.vue'
import nameValidator from 'foundation/js/inputValidators/nameValidator'
import emailValidator from 'foundation/js/inputValidators/emailValidator'
import { useStore } from 'vuex'
import fieldsConfig from './config/fieldsConfig'
import fieldValidator from 'foundation/js/stafet/fieldValidator'
import cprValidator from 'foundation/js/inputValidators/cprValidator'
import getItemFromStorage from 'foundation/js/sessionStorageWrapper/getItemFromStorage'
import sessionStorageIdentifierEnum from 'foundation/js/sessionStorageWrapper/sessionStorageIdentifierEnum'
import getFieldValue from 'foundation/js/stafet/getFieldValue'

export default {
    name: 'StafetDonationStepPrivat',
    components: {
        FormInputTextField,
        FormCheckbox,
        StafetPayment,
        StafetActions
    },
    props: _stafetCommonStepsProps,
    setup(props) {
        const store = useStore()
        const firstName = ref(props.userData?.firstName ?? '')
        const lastName = ref(props.userData?.lastName ?? '')
        const email = ref(props.userData?.email ?? '')
        const isAnonymous = ref(false)
        const taxDeduction = ref(false)
        const cpr = ref('')

        const basket = computed(() => {
            return store.state.donation.basket
        })

        const basketTotalPrice = computed(() => {
            return store.state.donation.basketTotalPrice
        })

        onBeforeMount(() => {
            const storedFields = getItemFromStorage(
                sessionStorageIdentifierEnum.STAFET_DONATION
            )

            if (storedFields) {
                if (getFieldValue(storedFields, 'firstName')) {
                    firstName.value = getFieldValue(storedFields, 'firstName')
                }
                if (getFieldValue(storedFields, 'lastName')) {
                    lastName.value = getFieldValue(storedFields, 'lastName')
                }
                if (getFieldValue(storedFields, 'email')) {
                    email.value = getFieldValue(storedFields, 'email')
                }
                if (getFieldValue(storedFields, 'isAnonymous')) {
                    isAnonymous.value = getFieldValue(
                        storedFields,
                        'isAnonymous'
                    )
                }
                if (getFieldValue(storedFields, 'taxDeduction')) {
                    taxDeduction.value = getFieldValue(
                        storedFields,
                        'taxDeduction'
                    )
                }
                if (getFieldValue(storedFields, 'cpr')) {
                    cpr.value = getFieldValue(storedFields, 'cpr')
                }
            }

            validateField('lastName', lastName.value)
            validateField('email', email.value)
            validateField('isAnonymous', isAnonymous.value)
            validateField('taxDeduction', taxDeduction.value)
            validateField('cpr', cpr.value)
            validateField('firstName', firstName.value)
        })

        const showFirstNameErrorMessage = computed(() => {
            return !nameValidator(firstName.value) && props.displayInputError
        })

        const showLastNameErrorMessage = computed(() => {
            return !nameValidator(lastName.value) && props.displayInputError
        })

        const showEmailErrorMessage = computed(() => {
            return !emailValidator(email.value) && props.displayInputError
        })

        const showCprErrorMessage = computed(() => {
            return !cprValidator(cpr.value) && props.displayInputError
        })

        const setTaxDeduction = (value) => {
            taxDeduction.value = value
            validateField('taxDeduction', value)
        }

        const validateField = (fieldName, value) => {
            fieldsConfig.find((item) => item.name === fieldName).value = value
            const field = fieldsConfig.find((field) => field.name === fieldName)
            if (field) {
                field.value = value
                fieldValidator(field)
            }
        }

        const stepModel = computed(() => {
            return fieldsConfig
        })

        return {
            firstName,
            lastName,
            email,
            isAnonymous,
            taxDeduction,
            cpr,
            basket,
            basketTotalPrice,
            stepModel,
            validateField,
            setTaxDeduction,
            showFirstNameErrorMessage,
            showLastNameErrorMessage,
            showEmailErrorMessage,
            showCprErrorMessage
        }
    }
}
